import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = 1;
export const pageInitialState = initialState;

const pageSlice = createSlice({
  name: 'page',
  initialState,
  reducers: {
    setPage(_, action: PayloadAction<number>) {
      return action.payload;
    },
  },
});

export const { setPage } = pageSlice.actions;
export const { reducer: pageReducer } = pageSlice;
